import { render } from "./MobileHome.vue?vue&type=template&id=0ce4f4a9&scoped=true"
import script from "./MobileHome.vue?vue&type=script&lang=js"
export * from "./MobileHome.vue?vue&type=script&lang=js"

import "./MobileHome.vue?vue&type=style&index=0&id=0ce4f4a9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ce4f4a9"

export default script